module.exports = __webpack_public_path__ + "img/electric-mining-drill-S-drill-shadow.8fb3e0b7.png";